import React from "react";
import Logo from "./../../assets/images/logo.png";
import Menu from "./../../assets/images/menu.png";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

import "./navbar.css";
const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  return (
    <>
      <div className="navbar">
        <button className="toggle" onClick={toggleDrawer}>
          <img src={Menu} alt="toggle" />
        </button>
        <div>
          <img src={Logo} alt="" />
        </div>

        <ul >
          <li>
            <a href="#about">About us</a>
          </li>
          <li>
            <a href="#discover">Discover</a>
          </li>
          <li>
            <a href="#shop">Shop</a>
          </li>
          <li>
            <a href="#contact">Contacts</a>
          </li>
        </ul>

        <div className="toggle" />
      </div>

      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        className="bla bla bla"
      >
        <ul className="mobile_links" onClick={()=>setIsOpen(false)}>
          <li>
            <a href="#about">About us</a>
          </li>
          <li>
            <a href="#discover">Discover</a>
          </li>
          <li>
            <a href="#shop">Shop</a>
          </li>
          <li>
            <a href="#contact">Contacts</a>
          </li>
        </ul>
      </Drawer>
    </>
  );
};

export default Navbar;
